import { computed, observable, action } from 'mobx';
import request from 'superagent';
import Transport from './Transport';

const VERBS_MAP = {
	del: 'DELETE',
	all: 'POST',
};

/**
 * Транспорт по протоколу REST с сервером
 */
export default class Rest extends Transport {

	/**
	 * Свойства передаваемые при отправке запросов
	 */
	_options = {
		headers: {
			'Content-Type': 'application/json'
		},
		credentials: 'same-origin',
	};

	/**
	 * Информация о сервере
	 */
	_info;

	/**
	 * Последняя ошибка полученная от сервера
	 */
	@observable error;

	constructor (url = '/api', options) {
		super (url);
		this._options = options || this._options;
	}

	/**
	 * Признак того что транспорт сейчас выполняет запрос
	 */
	@computed get isLoading () {
		return this._pendingRequestCount > 0;
	}

	/**
	 * Вызов метода модели на сервере
	 */
	@action async invoke ({model, id = null, method, args}) {
		let path = `${model.path}${!method.isStatic && id ? `/${id}` : ''}`;
		let http = Array.isArray (method.http) ? method.http [0] : method.http;
		let methodPath = http.path;
		let accepts = method.accepts;
		let body;
		let verb = http.verb;
		let query = [];
		let headers = {};

		for (let i = 0; i < accepts.length; i ++) {
			let accept = accepts [i];
			let source = accept.http ? accept.http.source || '' : '';
			switch (source) {
				case 'body':
					body = args [i];
				break;

				case 'form':
				case 'formData':
					body = body || {};
					body [accept.arg] = args [i];
				break;

				case 'path':
					methodPath = methodPath.replace (`:${accept.arg}`, args [i]);
				break;

				case 'query':
					args [i] !== undefined && query.push (`${accept.arg}=${encodeURIComponent(JSON.stringify(args [i]))}`);
				break;

				case 'header':
					headers [accept.arg] = args [i];
				break;

				default:

					if (verb === 'get') {
						args [i] !== undefined && query.push (`${accept.arg}=${encodeURIComponent(JSON.stringify(args [i]))}`);
					} else {
						body = body || {};
						body [accept.arg] = args [i];
					}

				break;
			}
		}

		verb = VERBS_MAP[verb] || verb.toUpperCase ();
		
		return this.fetch (`${path}${methodPath}${query ? `?${query.join ('&')}` : ''}`, {
			method: verb, // LB sucks
			body: body !== undefined ? JSON.stringify (body) : undefined,
			headers
		});
	}

	/**
	 * Подключиться к серверу
	 */
	@action async connect () {
		try {
			this._info = await this.fetch ('/', {method: 'GET'});
			this.isConnected = true;
		} catch (error) {
			this.isConnected = false;
		}

		return this._info;
	}

	/**
	 * Выполнить запрос на сервер
	 */
	async fetch (path, options) {
		let response;
		let error;
		let totalCount;
		let headers = { ...this._options.headers, ...options.headers };
		this._pendingRequestCount++;
		try {
			// console.log('fetch:', this._url + path, 'headers', headers);
			response = await fetch(this._url + path, { ...this._options, ...options, headers });
		}
		catch(e) {
			console.warn('не найдена запись', path, e);
			error = e;
		}
		this._pendingRequestCount --;
		
		if (error) throw error;
		
		// TODO: check status = 204 - No content leads to exception
		let json = {};
		try {
			json = await response.json ();
		}
		catch(error) {}
		
		if (!response.ok) {
			throw json.error;
		}

		totalCount = response.headers.get('x-total-count');

		if (totalCount) {
			json.totalCount = parseInt (totalCount) || 0;
		}

		return json;
	}

	uploadFile (modelPath, id, property, file, container) {
		let url = `${this._url}/${container || 'containers'}${modelPath}/upload`;
		return request.post (url).attach (property, file, `${id}-${property}`);
	}

	downloadFile (modelPath, id, property, container) {
		return `${this._url}/${container || 'containers'}${modelPath}/download/${id}-${property}`;
	}

	deleteFile (modelPath, id, property, container) {
		// TODO: почему то не работает без await
		return request.del (`${this._url}/${container || 'containers'}${modelPath}/files/${id}-${property}`);
	}
}
